import {TYPE_RADIO_BUTTONS} from "../../../model-constants/quiz/types";

let autoIncId = 0;
const genId = () => --autoIncId;


export default function (group_id = null, sort_order = 0) {
    return {
        id: genId(),
        group_id: group_id,
        type: TYPE_RADIO_BUTTONS,
        title: '',
        content: '',
        answer_values: [[]],
        answer_explanation: '',
        score: 1,
        sort_order: sort_order,
    };
}
